/* MANCE Shopify Theme JS */
(function () {
  'use strict';

  var routes = window.routes || {};
  var body = document.body;

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileMenu) {
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
      }
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileMenu) {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
      }
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }
  function updateCartSubtotal(price) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = price;
    });
  }

  function renderCartItems(html) {
    var container = document.querySelector('[data-cart-items]');
    if (container) container.innerHTML = html;
  }

  function fetchCart() {
    return fetch(routes.cart_url + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var countEl = doc.querySelector('[data-cart-count]');
        if (countEl) updateCartCount(countEl.textContent);
        var subtotalEl = doc.querySelector('[data-cart-subtotal]');
        if (subtotalEl) updateCartSubtotal(subtotalEl.textContent);
        var itemsEl = doc.querySelector('[data-cart-items]');
        if (itemsEl) renderCartItems(itemsEl.innerHTML);
        var foot = doc.querySelector('.cart-drawer__foot');
        var existingFoot = cartDrawer && cartDrawer.querySelector('.cart-drawer__foot');
        if (foot && existingFoot) {
          existingFoot.outerHTML = foot.outerHTML;
        } else if (!foot && existingFoot) {
          existingFoot.remove();
        }
      });
  }

  /* Quick add from product cards */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetchCart();
      })
      .then(function () { openCart(); })
      .catch(function () {
        /* fallback to full cart page */
        window.location.href = routes.cart_url;
      });
  });

  /* Quantity controls in drawer */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var line = item.getAttribute('data-line');
    var qtyEl = item.querySelector('[data-qty-value]');
    var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

    if (e.target.closest('[data-qty-increase]')) {
      changeLine(line, current + 1);
    } else if (e.target.closest('[data-qty-decrease]')) {
      changeLine(line, current - 1);
    }
  });

  function changeLine(line, quantity) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity }),
    })
      .then(function () { return fetchCart(); })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Product page ---------- */

  /* Local money formatter (replaces reliance on the global Shopify object,
     which is not always present and previously threw a ReferenceError). */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '£{{amount}}';

    function defaultTo(value, def) { return value == null || value !== value ? def : value; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value = '';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  var productForm = document.querySelector('[data-product-form]');
  var productJsonEl = document.querySelector('[data-product-json]');
  if (productForm && productJsonEl) {
    var product = {};
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) {}

    var variantIdInput = productForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var optionInputs = productForm.querySelectorAll('[data-option-input]');
    var mainImage = document.getElementById('ProductMainImage');
    var addBtn = productForm.querySelector('[data-add-button]');
    var addText = productForm.querySelector('[data-add-text]');
    var moneyFormat = window.themeMoneyFormat || '£{{amount}}';
    var strings = window.themeStrings || {};
    var strAdd = strings.addToCart || 'Add to cart';
    var strSoldOut = strings.soldOut || 'Sold out';
    var strUnavailable = strings.unavailable || 'Unavailable';
    var strAdding = strings.adding || 'Adding…';
    var strAdded = strings.added || 'Added';

    function getSelectedOptions() {
      var opts = {};
      optionInputs.forEach(function (input) {
        if (input.checked) opts[input.name.replace(/^options\[/, '').replace(/\]$/, '')] = input.value;
      });
      return opts;
    }

    function findVariant() {
      var selected = getSelectedOptions();
      var variants = product.variants || [];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var optName = product.options[i];
          return selected[optName] === opt;
        });
      });
    }

    function renderPrice(v) {
      if (!priceEl || v.price === undefined) return;
      var html = '<span class="product-page__price">' + formatMoney(v.price, moneyFormat) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html = '<span class="product-page__price product-page__price--sale">' + formatMoney(v.price, moneyFormat) + '</span>' +
               '<s class="product-page__compare">' + formatMoney(v.compare_at_price, moneyFormat) + '</s>';
      }
      priceEl.innerHTML = html;
    }

    function updateVariant() {
      var v = findVariant();
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = strUnavailable;
        return;
      }
      if (variantIdInput) variantIdInput.value = v.id;
      renderPrice(v);
      if (addBtn && addText) {
        if (v.available) {
          addBtn.disabled = false;
          addText.textContent = strAdd;
        } else {
          addBtn.disabled = true;
          addText.textContent = strSoldOut;
        }
      }
      /* Swap main image to the selected variant's image when present */
      if (mainImage && v.featured_image && v.featured_image.src) {
        mainImage.src = v.featured_image.src;
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    /* Thumbnail switching */
    var thumbs = document.querySelectorAll('[data-thumb-image]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage) mainImage.src = thumb.getAttribute('data-thumb-image');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
    if (thumbs.length && thumbs[0]) thumbs[0].classList.add('is-active');

    /* Quantity on product page */
    var qtyInput = productForm.querySelector('[data-qty-value]');
    productForm.querySelectorAll('[data-qty-increase]').forEach(function (b) {
      b.addEventListener('click', function () { if (qtyInput) qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    });
    productForm.querySelectorAll('[data-qty-decrease]').forEach(function (b) {
      b.addEventListener('click', function () { if (qtyInput && parseInt(qtyInput.value, 10) > 1) qtyInput.value = parseInt(qtyInput.value, 10) - 1; });
    });

    /* AJAX add-to-cart -> open the slide-out cart drawer */
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var formData = new FormData(productForm);
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = strAdding;
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return fetchCart(); })
        .then(function () {
          if (addText) addText.textContent = strAdded;
          openCart();
          setTimeout(function () {
            if (addText) addText.textContent = strAdd;
            if (addBtn) addBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          /* Fallback to a standard form submission if AJAX fails.
             Calling the DOM .submit() method does not re-dispatch the
             submit event, so this listener will not fire recursively. */
          if (addBtn) addBtn.disabled = false;
          if (addText) addText.textContent = strAdd;
          productForm.submit();
        });
    });
  }

  /* ESC closes overlays */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      if (mobileMenu) { mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden', 'true'); }
    }
  });
})();
